import { render, staticRenderFns } from "./ProfileServerLoading.vue?vue&type=template&id=617bde88&"
import script from "./ProfileServerLoading.vue?vue&type=script&lang=js&"
export * from "./ProfileServerLoading.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports